import React from "react";
import { Routes, Route } from "react-router-dom";
import Footer from "./nav/Footer";
import AdminFooter from "./management/Footer";

const SwitchFooter: React.FC = () => {
  return (
    <Routes>
      <Route path="/jikei" element={<AdminFooter />} />
      <Route path="/admin" element={<AdminFooter />} />
      <Route path="*" element={<Footer />} />
    </Routes>
  );
};

export default SwitchFooter;
